<!-- Standalone Form (used inside product-details modal wrapper) -->
<div *ngIf="standalone">
  <!-- Product Info -->
  <div *ngIf="product" class="flex items-center gap-3 bg-gray-50 border border-gray-200 rounded-xl px-3 py-2.5 mb-4">
    <div class="w-14 h-14 rounded-lg bg-white border border-gray-200 flex items-center justify-center flex-shrink-0 overflow-hidden p-1">
      <img *ngIf="productImage || product?.documents?.[0]?.url"
        [src]="productImage || product.documents[0].url" [alt]="product.label"
        class="w-full h-full object-contain">
      <svg *ngIf="!productImage && !product?.documents?.[0]?.url" class="w-8 h-8 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
      </svg>
    </div>
    <div class="min-w-0 flex-1">
      <p class="text-sm font-semibold text-gray-900 leading-snug line-clamp-2">{{ product.label }}</p>
      <p class="text-xs text-gray-500 mt-1">{{ product.category?.label || 'Produkt' }} {{ '· Nr ref.:' | translate }} {{ product.reference || product.code || '' }}</p>
    </div>
  </div>

  <form [formGroup]="quotationForm" (ngSubmit)="onSubmit()" class="space-y-4 quotation-form">

    <!-- Section: Personal -->
    <div>
      <p class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">{{ 'Dane kontaktowe' | translate }}</p>
      <div class="grid grid-cols-1 sm:grid-cols-[auto_1fr_1fr] gap-3">
        <!-- Title -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'Tytuł' | translate }} <span class="text-orange-500">*</span></label>
          <div class="relative block sm:inline-block">
            <select formControlName="title"
              class="appearance-none w-full sm:w-auto pl-4 pr-9 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white transition-all cursor-pointer"
              [class.border-red-300]="quotationForm.get('title')?.invalid && quotationForm.get('title')?.touched">
              <option value="" disabled hidden>{{ 'Tytuł' | translate }}</option>
              <option value="Mr">{{ 'Pan' | translate }}</option>
              <option value="Mrs">{{ 'Pani' | translate }}</option>
              <option value="Dr">{{ 'Dr' | translate }}</option>
              <option value="Eng">{{ 'Inż.' | translate }}</option>
              <option value="Other">{{ 'Inny' | translate }}</option>
            </select>
            <svg class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M19 9l-7 7-7-7"/>
            </svg>
          </div>
          <p *ngIf="quotationForm.get('title')?.invalid && quotationForm.get('title')?.touched" class="text-red-500 text-xs mt-1">{{ 'To pole jest wymagane.' | translate }}</p>
          <input *ngIf="quotationForm.get('title')?.value === 'Other'" type="text" formControlName="otherTitle"
            [placeholder]="'Wpisz tytuł' | translate" class="mt-2 w-full px-4 py-3 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-orange-500">
        </div>
        <!-- First Name -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'Imię' | translate }} <span class="text-orange-500">*</span></label>
          <input type="text" formControlName="firstName" [placeholder]="'Wpisz imię' | translate"
            class="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all"
            [class.border-red-300]="quotationForm.get('firstName')?.invalid && quotationForm.get('firstName')?.touched">
          <p *ngIf="quotationForm.get('firstName')?.invalid && quotationForm.get('firstName')?.touched" class="text-red-500 text-xs mt-1">{{ 'To pole jest wymagane.' | translate }}</p>
        </div>
        <!-- Last Name -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'Nazwisko' | translate }} <span class="text-orange-500">*</span></label>
          <input type="text" formControlName="lastName" [placeholder]="'Wpisz nazwisko' | translate"
            class="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all"
            [class.border-red-300]="quotationForm.get('lastName')?.invalid && quotationForm.get('lastName')?.touched">
          <p *ngIf="quotationForm.get('lastName')?.invalid && quotationForm.get('lastName')?.touched" class="text-red-500 text-xs mt-1">{{ 'To pole jest wymagane.' | translate }}</p>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <!-- Phone -->
    <div>
      <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'Telefon' | translate }} <span class="text-orange-500">*</span></label>
      <div class="flex rounded-lg overflow-hidden border border-gray-200 focus-within:ring-2 focus-within:ring-orange-500 transition-all"
        [class.border-red-300]="quotationForm.get('phone')?.invalid && quotationForm.get('phone')?.touched">
        <div class="relative country-selector flex-shrink-0">
          <button type="button" (click)="toggleCountryDropdown()"
            class="flex items-center gap-1.5 px-3 py-3 bg-gray-50 border-r border-gray-200 hover:bg-gray-100 transition-colors h-full text-sm font-medium text-gray-700">
            <span>{{ selectedCountryCode.flag }}</span>
            <span>{{ selectedCountryCode.code || 'Kod' }}</span>
            <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
            </svg>
          </button>
          <div *ngIf="showCountryDropdown" class="absolute top-full left-0 z-50 mt-1 w-64 bg-white border border-gray-200 rounded-xl shadow-xl max-h-56 overflow-y-auto">
            <div class="p-2 border-b border-gray-100">
              <input type="text" [(ngModel)]="countrySearchTerm" [ngModelOptions]="{standalone: true}" [placeholder]="'Szukaj...' | translate"
                class="w-full px-3 py-1.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-orange-500">
            </div>
            <div class="overflow-y-auto max-h-40">
              <button type="button" *ngFor="let country of getFilteredCountries()" (click)="selectCountryCode(country)"
                class="w-full flex items-center gap-2 px-3 py-2 text-left hover:bg-orange-50 text-sm transition-colors">
                <span>{{ country.flag }}</span>
                <span class="flex-1 text-gray-800">{{ country.name }}</span>
                <span class="text-gray-400 text-xs">{{ country.code }}</span>
              </button>
            </div>
          </div>
        </div>
        <input type="tel" formControlName="phone" [placeholder]="'Wpisz numer telefonu' | translate"
          class="flex-1 min-w-0 px-3 py-3 text-sm focus:outline-none bg-white">
      </div>
      <p *ngIf="quotationForm.get('phone')?.invalid && quotationForm.get('phone')?.touched" class="text-red-500 text-xs mt-1">{{ 'Numer telefonu jest wymagany.' | translate }}</p>
    </div>

    <!-- Country -->
    <div>
      <label class="block text-sm font-semibold text-gray-700 mb-2">
        {{ 'Kraj' | translate }} <span class="text-orange-500">*</span>
        <button type="button" (click)="detectUserCountry()" [disabled]="isDetectingLocation"
          class="ml-2 text-orange-500 hover:text-orange-700 text-xs font-normal underline disabled:opacity-50">
          <span *ngIf="isDetectingLocation">{{ 'Wykrywanie…' | translate }}</span>
          <span *ngIf="!isDetectingLocation">{{ '📍 Wykryj automatycznie' | translate }}</span>
        </button>
      </label>
      <div class="relative w-full delivery-country-selector">
        <button type="button" (click)="toggleDeliveryCountryDropdown()"
          [attr.aria-expanded]="isDeliveryCountryDropdownOpen"
          class="w-full flex items-center justify-between gap-3 px-4 py-3 border border-gray-200 rounded-lg text-sm bg-white text-left transition-all focus:outline-none focus:ring-2 focus:ring-orange-500"
          [class.border-red-300]="quotationForm.get('country')?.invalid && quotationForm.get('country')?.touched"
          [class.ring-2]="isDeliveryCountryDropdownOpen"
          [class.ring-orange-500]="isDeliveryCountryDropdownOpen">
          <span class="flex items-center gap-2 min-w-0">
            <span>{{ quotationForm.get('country')?.value ? getDeliveryCountryFlag(quotationForm.get('country')?.value) : '🌐' }}</span>
            <span class="truncate text-gray-800">{{ getDeliveryCountryName(quotationForm.get('country')?.value) }}</span>
          </span>
          <svg class="w-4 h-4 shrink-0 text-gray-400 transition-transform" [class.rotate-180]="isDeliveryCountryDropdownOpen"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 9-7 7-7-7"/>
          </svg>
        </button>
        <div *ngIf="isDeliveryCountryDropdownOpen"
          class="absolute z-[100] left-0 right-0 mt-1.5 bg-white border border-gray-200 rounded-xl shadow-xl overflow-hidden">
          <div class="p-2 border-b border-gray-100 bg-gray-50">
            <input type="search" [(ngModel)]="deliveryCountrySearchTerm" [ngModelOptions]="{standalone: true}"
              [placeholder]="'Szukaj kraju...' | translate" [attr.aria-label]="'Szukaj kraju dostawy' | translate"
              class="w-full px-3 py-2 text-sm bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500">
          </div>
          <div class="max-h-52 overflow-y-auto py-1">
            <button type="button" *ngFor="let country of getFilteredDeliveryCountries()"
              (click)="selectDeliveryCountry(country)"
              class="w-full flex items-center gap-2.5 px-3 py-2 text-left text-sm text-gray-700 hover:bg-orange-50 transition-colors">
              <span class="text-base">{{ getDeliveryCountryFlag(country.code) }}</span>
              <span class="flex-1 truncate">{{ country.name }}</span>
              <span class="text-xs text-gray-400">{{ country.code }}</span>
            </button>
            <p *ngIf="getFilteredDeliveryCountries().length === 0" class="px-3 py-4 text-sm text-center text-gray-500">
              {{ 'Nie znaleziono krajów.' | translate }}
            </p>
          </div>
        </div>
      </div>
      <p *ngIf="quotationForm.get('country')?.invalid && quotationForm.get('country')?.touched" class="text-red-500 text-xs mt-1">{{ 'Wybierz kraj.' | translate }}</p>
    </div>
    </div>

    <!-- Divider -->
    <div class="border-t border-gray-100 pt-1">
      <p class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">{{ 'Dane firmy' | translate }}</p>
    </div>

    <div class="grid grid-cols-1 min-[540px]:grid-cols-3 gap-3">
      <div>
        <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'Nazwa firmy' | translate }}</label>
        <input type="text" formControlName="companyName" [placeholder]="'Wpisz nazwę firmy' | translate"
          class="w-full px-3 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all">
      </div>
      <div>
        <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'NIP' | translate }} <span class="text-orange-500">*</span></label>
        <input type="text" formControlName="taxId" [placeholder]="'Wpisz NIP' | translate"
          class="w-full px-3 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all"
          [class.border-red-300]="quotationForm.get('taxId')?.invalid && quotationForm.get('taxId')?.touched">
        <p *ngIf="quotationForm.get('taxId')?.invalid && quotationForm.get('taxId')?.touched" class="text-red-500 text-xs mt-1">{{ 'To pole jest wymagane.' | translate }}</p>
      </div>
      <div>
        <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'E-mail' | translate }} <span class="text-orange-500">*</span></label>
        <input type="email" formControlName="email" [placeholder]="'twoj&#64;adres.pl' | translate"
          class="w-full px-3 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all"
          [class.border-red-300]="quotationForm.get('email')?.invalid && quotationForm.get('email')?.touched">
        <p *ngIf="quotationForm.get('email')?.touched && quotationForm.get('email')?.errors?.['required']" class="text-red-500 text-xs mt-1">{{ 'Adres e-mail jest wymagany.' | translate }}</p>
        <p *ngIf="quotationForm.get('email')?.touched && quotationForm.get('email')?.errors?.['email']" class="text-red-500 text-xs mt-1">{{ 'Wpisz prawidłowy adres e-mail.' | translate }}</p>
      </div>
    </div>

    <!-- Divider -->
    <div class="border-t border-gray-100 pt-1">
      <p class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">{{ 'Twoje zapytanie' | translate }}</p>
    </div>

    <!-- Question -->
    <div>
      <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'Wiadomość' | translate }} <span class="text-orange-500">*</span></label>
      <textarea formControlName="question" rows="3" [placeholder]="'Opisz swoje wymagania, ilości, oczekiwany termin dostawy lub zadaj pytanie…' | translate"
        class="w-full px-4 py-3 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all resize-none"
        [class.border-red-300]="quotationForm.get('question')?.invalid && quotationForm.get('question')?.touched"></textarea>
      <p *ngIf="quotationForm.get('question')?.invalid && quotationForm.get('question')?.touched" class="text-red-500 text-xs mt-1">{{ 'Wpisz treść zapytania.' | translate }}</p>
    </div>

    <!-- File Attachment -->
    <div>
      <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'Załączniki' | translate }} <span class="text-gray-400 font-normal">{{ '(opcjonalnie)' | translate }}</span></label>
      <div class="relative">
        <input type="file" (change)="onFileSelected($event)" class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
          accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.txt,.xlsx,.xls" multiple>
        <div class="flex items-center gap-3 px-4 py-3 border border-dashed border-gray-300 rounded-lg hover:border-orange-400 transition-colors cursor-pointer">
          <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
          </svg>
          <span class="text-sm text-gray-500"><span class="text-orange-500 font-medium">{{ 'Wybierz pliki' | translate }}</span>{{ ', aby dodać dokumenty PDF, Word, Excel, obrazy lub pliki tekstowe (maksymalnie 5 plików po 10 MB)' | translate }}</span>
        </div>
      </div>
      <div *ngIf="selectedFiles && selectedFiles.length > 0" class="mt-2 space-y-1.5">
        <div *ngFor="let file of selectedFiles; let i = index"
          class="flex items-center justify-between bg-gray-50 px-3 py-2 rounded-lg border border-gray-100">
          <div class="flex items-center gap-2 min-w-0">
            <svg class="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            </svg>
            <span class="text-xs text-gray-700 truncate">{{ file.name }}</span>
            <span class="text-xs text-gray-400 flex-shrink-0">{{ getFileSize(file.size) }}</span>
          </div>
          <button type="button" (click)="removeFile(i)" class="ml-2 text-red-400 hover:text-red-600 flex-shrink-0">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div>
      <label for="quotation-terms-standalone" class="flex items-start gap-2 text-sm text-gray-700">
        <input id="quotation-terms-standalone" type="checkbox" formControlName="termsAgreement" required
          aria-required="true"
          [attr.aria-invalid]="quotationForm.get('termsAgreement')?.invalid && quotationForm.get('termsAgreement')?.touched"
          [attr.aria-describedby]="quotationForm.get('termsAgreement')?.invalid && quotationForm.get('termsAgreement')?.touched ? 'quotation-terms-standalone-error' : null"
          class="mt-1 h-4 w-4 shrink-0 rounded border-gray-300 text-orange-600 focus:ring-orange-500">
        <span>
          {{ 'Akceptuję' | translate }}
          <a routerLink="/legal/terms-and-conditions" target="_blank" rel="noopener"
            class="font-medium text-orange-600 underline hover:text-orange-700">{{ 'Regulamin' | translate }}</a>
          {{ 'oraz' | translate }}
          <a routerLink="/legal/privacy-policy" target="_blank" rel="noopener"
            class="font-medium text-orange-600 underline hover:text-orange-700">{{ 'Politykę prywatności' | translate }}</a>.
        </span>
      </label>
      <p *ngIf="quotationForm.get('termsAgreement')?.invalid && quotationForm.get('termsAgreement')?.touched"
        id="quotation-terms-standalone-error" class="mt-1 text-xs text-red-600" role="alert">
        {{ 'Zaakceptuj Regulamin i Politykę prywatności, aby wysłać zapytanie.' | translate }}
      </p>
    </div>

    <!-- Required note -->
    <p class="text-gray-400 text-xs"><span class="text-orange-500">*</span> {{ 'Pola wymagane' | translate }}</p>

    <!-- Submit -->
    <button type="submit" [disabled]="isSubmitting"
      class="w-full py-3 px-6 bg-orange-500 hover:bg-orange-600 disabled:opacity-60 disabled:cursor-not-allowed text-white font-semibold rounded-xl transition-all flex items-center justify-center gap-2 shadow-sm">
      <svg *ngIf="isSubmitting" class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
      </svg>
      <svg *ngIf="!isSubmitting" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"/>
      </svg>
      {{ isSubmitting ? 'Wysyłanie…' : 'Wyślij zapytanie' }}
    </button>
  </form>
</div>

<!-- Full Modal (non-standalone) -->
<div class="fixed inset-0 z-50 flex items-center justify-center p-4" *ngIf="showModal && !standalone">
  <div class="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm" (click)="closeModal()"></div>
  <div class="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
    <div class="bg-white border-b border-gray-100 px-6 py-5 rounded-t-2xl flex items-center justify-between">
      <div>
        <h2 class="text-xl font-bold text-gray-900">{{ 'Zapytanie o wycenę' | translate }}</h2>
        <p class="text-gray-500 text-sm mt-0.5">{{ 'Odpowiemy w ciągu 24 godzin.' | translate }}</p>
      </div>
      <button (click)="closeModal()" class="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center transition-colors text-gray-400 hover:text-gray-600">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>
    <div class="p-6">
      <!-- Embed standalone content inline for modal mode -->
      <div *ngIf="product" class="flex items-center gap-4 bg-orange-50 border border-orange-100 rounded-2xl px-4 py-3.5 mb-5">
        <div class="w-16 h-16 rounded-xl bg-white border border-orange-100 flex items-center justify-center flex-shrink-0 overflow-hidden p-1 shadow-sm">
          <img *ngIf="productImage || product?.documents?.[0]?.url"
            [src]="productImage || product.documents[0].url" [alt]="product.label" class="w-full h-full object-contain">
          <svg *ngIf="!productImage && !product?.documents?.[0]?.url" class="w-8 h-8 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
          </svg>
        </div>
        <div class="min-w-0 flex-1">
          <p class="text-sm font-semibold text-gray-900 leading-snug line-clamp-2">{{ product.label }}</p>
          <p class="text-xs text-gray-500 mt-1">{{ product.category?.label || 'Produkt' }} {{ '· Nr ref.:' | translate }} {{ product.reference || product.code || '' }}</p>
        </div>
      </div>
      <form [formGroup]="quotationForm" (ngSubmit)="onSubmit()" class="space-y-4">
        <div class="grid grid-cols-3 gap-3">
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'Tytuł' | translate }} <span class="text-orange-500">*</span></label>
            <select formControlName="title" class="w-full px-3 py-3 border border-gray-200 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-orange-500 bg-white">
              <option value="" disabled hidden>{{ 'Wybierz' | translate }}</option>
              <option value="Mr">{{ 'Pan' | translate }}</option><option value="Mrs">{{ 'Pani' | translate }}</option>
              <option value="Dr">{{ 'Dr' | translate }}</option><option value="Eng">{{ 'Inż.' | translate }}</option><option value="Other">{{ 'Inny' | translate }}</option>
            </select>
          </div>
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'Imię' | translate }} <span class="text-orange-500">*</span></label>
            <input type="text" formControlName="firstName" [placeholder]="'Wpisz imię' | translate" class="w-full px-3 py-3 border border-gray-200 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-orange-500">
          </div>
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'Nazwisko' | translate }} <span class="text-orange-500">*</span></label>
            <input type="text" formControlName="lastName" [placeholder]="'Wpisz nazwisko' | translate" class="w-full px-3 py-3 border border-gray-200 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-orange-500">
          </div>
        </div>
        <div class="flex rounded-xl overflow-hidden border border-gray-200 focus-within:ring-2 focus-within:ring-orange-500">
          <div class="relative country-selector flex-shrink-0">
            <button type="button" (click)="toggleCountryDropdown()" class="flex items-center gap-1.5 px-3 py-2.5 bg-gray-50 border-r border-gray-200 hover:bg-gray-100 text-sm font-medium text-gray-700 h-full">
              <span>{{ selectedCountryCode.flag }}</span><span>{{ selectedCountryCode.code || 'Kod' }}</span>
              <svg class="w-3 h-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg>
            </button>
            <div *ngIf="showCountryDropdown" class="absolute top-full left-0 z-50 mt-1 w-64 bg-white border border-gray-200 rounded-xl shadow-xl max-h-56 overflow-y-auto">
              <div class="p-2 border-b border-gray-100">
                <input type="text" [(ngModel)]="countrySearchTerm" [ngModelOptions]="{standalone: true}" [placeholder]="'Szukaj...' | translate" class="w-full px-3 py-1.5 text-sm border border-gray-200 rounded-lg focus:outline-none">
              </div>
              <div class="overflow-y-auto max-h-40">
                <button type="button" *ngFor="let country of getFilteredCountries()" (click)="selectCountryCode(country)" class="w-full flex items-center gap-2 px-3 py-2 hover:bg-orange-50 text-sm">
                  <span>{{ country.flag }}</span><span class="flex-1">{{ country.name }}</span><span class="text-gray-400 text-xs">{{ country.code }}</span>
                </button>
              </div>
            </div>
          </div>
          <input type="tel" formControlName="phone" [placeholder]="'Numer telefonu' | translate" class="flex-1 px-3 py-2.5 text-sm focus:outline-none bg-white">
        </div>
        <div class="grid grid-cols-2 gap-3">
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'Kraj' | translate }} <span class="text-orange-500">*</span></label>
            <div class="relative w-full delivery-country-selector">
              <button type="button" (click)="toggleDeliveryCountryDropdown()"
                [attr.aria-expanded]="isDeliveryCountryDropdownOpen"
                class="w-full flex items-center justify-between gap-2 px-3 py-3 border border-gray-200 rounded-xl text-sm bg-white text-left transition-all focus:outline-none focus:ring-2 focus:ring-orange-500"
                [class.border-red-300]="quotationForm.get('country')?.invalid && quotationForm.get('country')?.touched"
                [class.ring-2]="isDeliveryCountryDropdownOpen"
                [class.ring-orange-500]="isDeliveryCountryDropdownOpen">
                <span class="flex items-center gap-2 min-w-0">
                  <span>{{ quotationForm.get('country')?.value ? getDeliveryCountryFlag(quotationForm.get('country')?.value) : '🌐' }}</span>
                  <span class="truncate text-gray-800">{{ getDeliveryCountryName(quotationForm.get('country')?.value) }}</span>
                </span>
                <svg class="w-4 h-4 shrink-0 text-gray-400 transition-transform" [class.rotate-180]="isDeliveryCountryDropdownOpen"
                  fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 9-7 7-7-7"/>
                </svg>
              </button>
              <div *ngIf="isDeliveryCountryDropdownOpen"
                class="absolute z-[100] left-0 right-0 mt-1.5 bg-white border border-gray-200 rounded-xl shadow-xl overflow-hidden">
                <div class="p-2 border-b border-gray-100 bg-gray-50">
                  <input type="search" [(ngModel)]="deliveryCountrySearchTerm" [ngModelOptions]="{standalone: true}"
                    [placeholder]="'Szukaj kraju...' | translate" [attr.aria-label]="'Szukaj kraju dostawy' | translate"
                    class="w-full px-3 py-2 text-sm bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500">
                </div>
                <div class="max-h-52 overflow-y-auto py-1">
                  <button type="button" *ngFor="let country of getFilteredDeliveryCountries()"
                    (click)="selectDeliveryCountry(country)"
                    class="w-full flex items-center gap-2.5 px-3 py-2 text-left text-sm text-gray-700 hover:bg-orange-50 transition-colors">
                    <span class="text-base">{{ getDeliveryCountryFlag(country.code) }}</span>
                    <span class="flex-1 truncate">{{ country.name }}</span>
                    <span class="text-xs text-gray-400">{{ country.code }}</span>
                  </button>
                  <p *ngIf="getFilteredDeliveryCountries().length === 0" class="px-3 py-4 text-sm text-center text-gray-500">
                    {{ 'Nie znaleziono krajów.' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'Nazwa firmy' | translate }}</label>
            <input type="text" formControlName="companyName" [placeholder]="'Wpisz nazwę firmy' | translate" class="w-full px-3 py-3 border border-gray-200 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-orange-500">
          </div>
        </div>
        <div class="grid grid-cols-2 gap-3">
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'NIP' | translate }} <span class="text-orange-500">*</span></label>
            <input type="text" formControlName="taxId" [placeholder]="'Wpisz NIP' | translate" class="w-full px-3 py-3 border border-gray-200 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-orange-500">
          </div>
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'E-mail' | translate }} <span class="text-orange-500">*</span></label>
            <input type="email" formControlName="email" [placeholder]="'twoj&#64;adres.pl' | translate" class="w-full px-3 py-3 border border-gray-200 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-orange-500">
          </div>
        </div>
        <div>
          <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'Wiadomość' | translate }} <span class="text-orange-500">*</span></label>
          <textarea formControlName="question" rows="3" [placeholder]="'Opisz swoje wymagania, ilości i oczekiwany termin…' | translate" class="w-full px-3 py-3 border border-gray-200 rounded-xl text-base focus:outline-none focus:ring-2 focus:ring-orange-500 resize-none"></textarea>
        </div>
        <div>
          <label for="quotation-terms-modal" class="flex items-start gap-2 text-sm text-gray-700">
            <input id="quotation-terms-modal" type="checkbox" formControlName="termsAgreement" required
              aria-required="true"
              [attr.aria-invalid]="quotationForm.get('termsAgreement')?.invalid && quotationForm.get('termsAgreement')?.touched"
              [attr.aria-describedby]="quotationForm.get('termsAgreement')?.invalid && quotationForm.get('termsAgreement')?.touched ? 'quotation-terms-modal-error' : null"
              class="mt-1 h-4 w-4 shrink-0 rounded border-gray-300 text-orange-600 focus:ring-orange-500">
            <span>
              {{ 'Zapoznałem(-am) się z dokumentami i akceptuję' | translate }}
              <a routerLink="/legal/terms-and-conditions" target="_blank" rel="noopener"
                class="font-medium text-orange-600 underline hover:text-orange-700">{{ 'Regulamin' | translate }}</a>
              {{ 'oraz' | translate }}
              <a routerLink="/legal/privacy-policy" target="_blank" rel="noopener"
                class="font-medium text-orange-600 underline hover:text-orange-700">{{ 'Politykę prywatności' | translate }}</a>.
            </span>
          </label>
          <p *ngIf="quotationForm.get('termsAgreement')?.invalid && quotationForm.get('termsAgreement')?.touched"
            id="quotation-terms-modal-error" class="mt-1 text-xs text-red-600" role="alert">
            {{ 'Zaakceptuj Regulamin i Politykę prywatności, aby wysłać zapytanie.' | translate }}
          </p>
        </div>
        <div class="flex gap-3 pt-2">
          <button type="button" (click)="closeModal()" class="flex-1 px-4 py-3 border border-gray-200 rounded-xl text-base font-medium text-gray-600 hover:bg-gray-50 transition-all">{{ 'Anuluj' | translate }}</button>
          <button type="submit" [disabled]="isSubmitting" class="flex-1 px-4 py-2.5 bg-orange-500 hover:bg-orange-600 text-white rounded-xl text-sm font-semibold transition-all flex items-center justify-center gap-2 disabled:opacity-60">
            <svg *ngIf="isSubmitting" class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/></svg>
            <svg *ngIf="!isSubmitting" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"/></svg>
            {{ isSubmitting ? 'Wysyłanie…' : 'Wyślij zapytanie' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>